import React from 'react'
import clsx from "clsx";
import Receipt from "@material-ui/icons/Receipt";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import { makeStyles, Step, StepConnector, StepLabel, Stepper, withStyles } from '@material-ui/core'

const ColorlibConnector = withStyles({
    alternativeLabel: {
        top: 22,
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: "#eaeaf0",
        borderRadius: 1,
    },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: "#fff",
        color: theme.palette.primary.main,
        zIndex: 1,
        width: 50,
        height: 50,
        display: "flex",
        borderRadius: "50%",
        borderColor: theme.palette.primary.main,
        borderWidth: 1,
        borderStyle: "solid",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold"
    },
    active: {
        backgroundColor: theme.palette.primary.main,
        color: "#fff"
    },
    completed: {

    }
}));

function ColorlibStepIcon(props) {
    const classes = useColorlibStepIconStyles();
    const { active, completed } = props;

    const icons = window.screen.availWidth < 500
        ?
            {
                1: <Receipt />,
            }
        :
            {
                1: <PeopleAltOutlinedIcon />,
                2: <Receipt />,
                3: <Receipt />,
                4: <Receipt />,
            };

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
            })}
        >
            {icons[String(props.icon)]}
        </div>
    );
}

const steps = ["BENEFICIARIA/O", "DETALLE", "COMPLEMENTO", "DIAGNOSTICO / DOCUMENTACIÓN"]
export const StepperDiscaAfiliado = ({step}) => {    
    return (
        <Stepper
            alternativeLabel
            activeStep={window.screen.availWidth < 500 ? 0 : step}
            connector={<ColorlibConnector />}
        >
            {window.screen.availWidth < 500
                ?
                    steps.filter((item, index) => index === step).map((label) => (
                        <Step key={label}>
                            <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
                        </Step>
                    ))
                :
                    steps.map((label) => (
                        <Step key={label}>
                            <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
                        </Step>
                    ))
            }
        </Stepper>
    )
}
